import { useStickerSectionStore } from "./EditorStore";
import localforage from "localforage";
import { CanvasDrawer } from "./CanvasDrawer";
import { UndoRedoHelper } from "./UndoRedoHelper";

export async function resetCanvas() {
    const setShowBackgroundImage = useStickerSectionStore.getState().setShowBackgroundImage;
    const setBackgroundBitmap = useStickerSectionStore.getState().setBackgroundBitmap;
    const setBackgroundColor = useStickerSectionStore.getState().setBackgroundColor;
    const setUndoRedo = useStickerSectionStore.getState().setUndoRedo;

    const cache = await caches.open("image-cache");

    CanvasDrawer.canvasImages = [];
    CanvasDrawer.BackgroundImageBitmap = null;
    setBackgroundBitmap(null);
    await cache.delete("backgroundImage");
    setShowBackgroundImage(true);
    await localforage.removeItem("showBackgroundImage");
    setBackgroundColor("#3d5a5a");
    await localforage.removeItem("backgroundColor");

    UndoRedoHelper.undoStack = [];
    UndoRedoHelper.isInitialized = false;
    UndoRedoHelper.createSnapShot();

    setUndoRedo({ canUndo: false, canRedo: false });

    CanvasDrawer.rerenderCanvas();
}
